import React from 'react';

export default class FaqQuestion extends React.Component {
  state = { isAnswerOpen: false };

  toggleAnswers = () => {
    this.setState(state => ({ isAnswerOpen: !state.isAnswerOpen }));
  };

  render() {
    const { faq } = this.props;
    const { isAnswerOpen } = this.state;
    return (
      <li key={faq.id}>
        <div
          className={`faq-header clickable ${isAnswerOpen ? 'active' : ''}`}
          onClick={this.toggleAnswers}
        >
          <h4>{faq.question}</h4>
          {isAnswerOpen ? <span>&#8212;</span> : <span>+</span>}
        </div>
        {isAnswerOpen && (
          <ul className="dropdown">
            {faq.answers.map((a, aKey) => (
              <li dangerouslySetInnerHTML={{ __html: a }} key={aKey} />
            ))}
          </ul>
        )}
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FaqQuestion.js